import React from "react";
import axios from "axios";
import Modal from "react-bootstrap/Modal";
import SideBar from "../SideBar";
import Header from "../Header";
import { Button } from "react-bootstrap";
// import { Link } from "react-router-dom";

class ViewAdmins extends React.Component {
  constructor() {
    super();
    this.state = {
      editMode: false,
      id: "",
      newStock: 0,
      vendor: "",
      stock: [],
      users: [],
      showModal: false,
    };
  }

  handleVendorChange = (e) => {
    this.setState({ vendor: e.target.value });
    // let config = this.state.user?.token
    //   ? {
    //       headers: { Authorization: `Token ${this.state.user.token}` },
    //       params: { orderType: this.state.orderType },
    //     }
    //   : {};
    let data = { user: e.target.value };
    axios
      .get(`${process.env.REACT_APP_API_URL}stock/`, { params: data })
      .then((res) => this.setState({ stock: res.data }));
  };

  disableUser = () => {
    var user = localStorage.getItem("user");
    var userData = JSON.parse(user);
    let config = {
      headers: { authorization: `Token ${userData.token}` },
    };
    let data = {
      id: this.state.id,
      isBlocked: true,
    };
    axios
      .put(`${process.env.REACT_APP_API_URL}user/user-visibility`, data, config)
      .then((res) => {
        console.log(res);
        this.componentDidMount();
      });
  };

  enableUser = () => {
    var user = localStorage.getItem("user");
    var userData = JSON.parse(user);
    let config = {
      headers: { authorization: `Token ${userData.token}` },
    };
    let data = {
      id: this.state.id,
      isBlocked: false,
    };
    axios
      .put(`${process.env.REACT_APP_API_URL}user/user-visibility`, data, config)
      .then((res) => {
        this.componentDidMount();
      });
  };

  handleModal = (modalState) => {
    this.setState({ showModal: modalState });
  };

  componentDidMount() {
    var user = localStorage.getItem("user");
    if (user) {
      var userData = JSON.parse(user);
      axios
        .get(`${process.env.REACT_APP_API_URL}user/admin-auth`, {
          headers: {
            authorization: "Bearer " + userData.token,
          },
        })
        .then((res) => {
          if (res.data.users.adminType !== "superAdmin") {
            this.props.history.push("/admin");
          }
          this.setState({ user: userData });
        })
        .catch((err) => {
          this.props.history.push("/");
        });
      axios
        .get(`${process.env.REACT_APP_API_URL}user/getadmins`, {})
        .then((res) =>
          this.setState(
            {
              users: res.data.users,
            },
            () => console.log(this.state)
          )
        );
    } else {
      this.props.history.push("/");
    }
  }

  handlePasswordSubmit = (e) => {
    e.preventDefault();
    var user = localStorage.getItem("user");
    var userData = JSON.parse(user);
    let config = {
      headers: { authorization: `Token ${userData.token}` },
    };
    let data = {
      id: this.state.id,
      newPassword: e.target.newPassword.value,
      confirmPassword: e.target.confirmPassword.value,
    };

    if (data.newPassword !== data.confirmPassword) {
      alert("Password does not match");
      return;
    }

    data.password = data.newPassword;

    console.log(data, config);
    axios
      .post(
        `${process.env.REACT_APP_API_URL}user/admin-change-password`,
        data,
        config
      )
      .then((res) => {
        this.handleModal(false);
      });
  };

  render() {
    console.log(this.state.tempVar);
    return (
      <>
        <Header />
        <div className="container-fluid">
          <div className="row">
            <SideBar />
            <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
              <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                <h1 className="h2 fw-bold">Admin Users</h1>
              </div>
              <div className="table-sec">
                <div className="table-responsive">
                  <table className="table table-borderless table-hover">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Email</th>
                        <th>Role</th>
                        <th>Edit</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.users.map((item, index) => (
                        <tr key={item._id}>
                          <td>{index}</td>
                          <td>{item.email}</td>
                          <td>{item?.adminType}</td>
                          <td>
                            {!item.isBlocked ? (
                              <button
                                className="btn text-sm btn-outline-secondary border-0"
                                onClick={() => {
                                  this.setState({ id: item._id }, () =>
                                    this.disableUser()
                                  );
                                }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16"
                                  height="16"
                                  fill="currentColor"
                                  class="bi bi-x-octagon"
                                  viewBox="0 0 16 16"
                                >
                                  <path d="M4.54.146A.5.5 0 0 1 4.893 0h6.214a.5.5 0 0 1 .353.146l4.394 4.394a.5.5 0 0 1 .146.353v6.214a.5.5 0 0 1-.146.353l-4.394 4.394a.5.5 0 0 1-.353.146H4.893a.5.5 0 0 1-.353-.146L.146 11.46A.5.5 0 0 1 0 11.107V4.893a.5.5 0 0 1 .146-.353L4.54.146zM5.1 1 1 5.1v5.8L5.1 15h5.8l4.1-4.1V5.1L10.9 1H5.1z" />
                                  <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                                </svg>
                              </button>
                            ) : (
                              <button
                                className="btn text-sm btn-outline-success"
                                onClick={() => {
                                  this.setState({ id: item._id }, () =>
                                    this.enableUser()
                                  );
                                }}
                              >
                                Enable
                              </button>
                            )}
                            <button
                              className="btn text-sm btn-outline-secondary border-0"
                              onClick={() => {
                                this.setState({ id: item._id }, () =>
                                  this.handleModal(true)
                                );
                              }}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={16}
                                height={16}
                                viewBox="0 0 32 32"
                                fill="currentColor"
                              >
                                <path d="M21 2a8.998 8.998 0 0 0-8.612 11.612L2 24v6h6l10.388-10.388A9 9 0 1 0 21 2Zm0 16a7.013 7.013 0 0 1-2.032-.302l-1.147-.348-.847.847-3.181 3.181L12.414 20 11 21.414l1.379 1.379-1.586 1.586L9.414 23 8 24.414l1.379 1.379L7.172 28H4v-3.172l9.802-9.802.848-.847-.348-1.147A7 7 0 1 1 21 18Z" />
                                <circle cx={22} cy={10} r={2} />
                                <path
                                  d="M0 0h32v32H0z"
                                  data-name="&lt;Transparent Rectangle&gt;"
                                  style={{
                                    fill: "none",
                                  }}
                                />
                              </svg>
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </main>
            <Modal
              show={this.state.showModal}
              onHide={() => this.handleModal(false)}
            >
              <Modal.Header>
                <Modal.Title>Change Password</Modal.Title>
              </Modal.Header>
              <form onSubmit={this.handlePasswordSubmit}>
                <Modal.Body>
                  <div className="form-group mb-4">
                    <label htmlFor="exampleInputEmail2">Email</label>
                    <input
                      type="email"
                      className="form-control"
                      id="exampleInputEmail2"
                      value={
                        this.state.users.filter(
                          (item) => item._id === this.state.id
                        )[0]?.email
                      }
                      disabled
                      placeholder="Enter new password"
                    />
                  </div>
                  <div className="form-group mb-4">
                    <label htmlFor="exampleInputEmail1">New Password</label>
                    <input
                      type="password"
                      className="form-control"
                      id="exampleInputEmail1"
                      aria-describedby="emailHelp"
                      name="newPassword"
                      placeholder="Enter new password"
                    />
                  </div>
                  <div className="form-group mb-4">
                    <label htmlFor="exampleInputPassword1">
                      Confirm Password
                    </label>
                    <input
                      type="password"
                      className="form-control"
                      id="exampleInputPassword1"
                      name="confirmPassword"
                      placeholder="Confirm new password"
                    />
                  </div>
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="primary" type="submit">
                    Update
                  </Button>
                  <Button
                    variant="secondary"
                    type="button"
                    onClick={() => this.handleModal(false)}
                  >
                    Cancel
                  </Button>
                </Modal.Footer>
              </form>
            </Modal>
          </div>
        </div>
      </>
    );
  }
}

export default ViewAdmins;
